import { render, staticRenderFns } from "./Supervisor.vue?vue&type=template&id=2cc9434c&"
import script from "./Supervisor.vue?vue&type=script&lang=js&"
export * from "./Supervisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports